const theme = {
    yellow: '#F5C51F',
    gray900: '#171A1C',
};

export default theme;